import { FC } from 'react';
import { Image, ImageProps } from '@chakra-ui/react';

import { BANK_ACCOUNT_ILLUSTRATIONS } from './constants';

export type BankAccountIllustrationName =
  keyof typeof BANK_ACCOUNT_ILLUSTRATIONS;

interface BankAccountIconProps
  extends Pick<ImageProps, 'border' | 'boxShadow'> {
  isDisabled?: boolean;
  illustrationName: BankAccountIllustrationName;
  size: keyof typeof SIZE_PROPS;
}

const SIZE_PROPS = {
  lg: {
    borderRadius: 'radius-16',
    boxSize: '64px',
    padding: 'space-4',
  },
  md: {
    borderRadius: 'radius-12',
    boxSize: '40px',
    padding: 'space-4',
  },
  sm: {
    borderRadius: 'radius-8',
    boxSize: '30px',
    padding: 0,
  },
  xl: {
    borderRadius: 'radius-24',
    boxSize: '84px',
    padding: 'space-4',
  },
  xs: {
    borderRadius: 'radius-8',
    boxSize: '24px',
    padding: 0,
  },
} as const;

const BankAccountIcon: FC<BankAccountIconProps> = ({
  border,
  boxShadow,
  illustrationName,
  isDisabled = false,
  size = 'md',
}) => (
  <Image
    alt={illustrationName}
    backgroundColor="grey.200"
    fit="cover"
    opacity={isDisabled ? 0.5 : 1}
    role="presentation"
    src={BANK_ACCOUNT_ILLUSTRATIONS[illustrationName]}
    {...SIZE_PROPS[size]}
    {...(border && { border })}
    {...(boxShadow && { boxShadow })}
  />
);

export default BankAccountIcon;
